import IconButton from "@mui/material/IconButton";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { useSnackbar, SnackbarKey } from "notistack";
import * as React from "react";

type SnackbarCloseButtonProps = {
  snackbarKey: SnackbarKey;
};

function SnackbarCloseButton({
  snackbarKey,
}: SnackbarCloseButtonProps) {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)}>
      <CancelRoundedIcon
        style={{
          position: "fixed",
          color: "#ffffff",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "18px",
          height: "18px",
        }}
      />
    </IconButton>
  );
}

export default SnackbarCloseButton;